"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateYears = void 0;
var generateYears = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.start, start = _c === void 0 ? 1950 : _c;
    var end = Number(new Date().getFullYear()) - 18;
    var result = [];
    for (var i = end; i >= start; i--) {
        result.push({ value: i, label: String(i) });
    }
    return result;
};
exports.generateYears = generateYears;
